/**
 * Прогрев движка карты (план 21.09, п.1). На маршруте `/v/…` чанк maplibre-gl
 * (270 КБ gz) грузится параллельно с venue.json, а не после него: main.tsx
 * зовёт warmEngine() при старте, VenueMap.create ждёт то же обещание — второго
 * запроса нет. Сразу после загрузки — `prewarm()`: пул воркеров создаётся до
 * первого `new Map`. Статический modulepreload не используется намеренно:
 * check:bundle запрещает тяжёлые чанки в index.html.
 */
import { engineFailed } from '../state'

type MapLibreModule = typeof import('maplibre-gl')

let pending: Promise<MapLibreModule> | null = null

/** Модуль maplibre-gl (с его css) — одно обещание на страницу. */
export function warmEngine(): Promise<MapLibreModule> {
  if (pending) return pending
  const p = Promise.all([import('maplibre-gl'), import('maplibre-gl/dist/maplibre-gl.css')]).then(
    ([lib]) => {
      lib.prewarm()
      engineFailed.value = false
      return lib
    },
  )
  p.catch(() => {
    // Чанк не пришёл (нет сети и нет кеша): следующий вызов попробует снова,
    // а режим ЧС покажет SVG-схему площадки вместо карты (emergency-svg).
    pending = null
    engineFailed.value = true
  })
  pending = p
  return p
}

/** Модуль карты площадки — тоже заранее, пока грузится venue.json. */
export function warmVenueMapModule(): Promise<typeof import('./venue-map')> {
  return import('./venue-map')
}
